// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AR wu","wrapperNeon":"AS wG","ribbon":"AT wD","title":"AU ww","seasons":"AV wB","genres":"AW wC","buttonWrapper":"AX wy","button":"AY wz","buttonNeon":"AZ wH"};